import * as yup from "yup";

import {
    BRANCH_SEQUENCE_TOKENS,
    DAY_VALUES,
} from "./LocationsForm/LocationIBTConfig/constants";

const nullableString = yup.string().nullable();

const TIME_FORMAT = /^([01]\d|2[0-3]):[0-5]\d:[0-5]\d$/;

const ibtSequenceSchema = yup.object().shape({
    timeRangeStart: yup
        .string()
        .required("Start time is required")
        .matches(TIME_FORMAT, "Start time must be in HH:MM:SS format"),
    timeRangeEnd: yup
        .string()
        .required("End time is required")
        .matches(TIME_FORMAT, "End time must be in HH:MM:SS format")
        .test(
            "after-start",
            "End time must be after start time",
            function (value) {
                const { timeRangeStart } = this.parent;
                if (!timeRangeStart || !value) {
                    return true;
                }
                return value > timeRangeStart;
            }
        ),
    daysOfWeek: yup
        .array()
        .of(yup.number().oneOf(DAY_VALUES))
        .min(1, "Select at least one day"),
    branchSequence: yup
        .array()
        .of(yup.string().oneOf(BRANCH_SEQUENCE_TOKENS))
        .min(1, "Select at least one branch")
        .test(
            "unique",
            "Each branch can only appear once in a sequence",
            (value) => !value || new Set(value).size === value.length
        ),
});

export default {
    metaDescription: nullableString,
    metaTitle: nullableString,
    line1: yup.string().required(),
    line2: nullableString,
    line3: nullableString,
    website: nullableString,
    specialOpeningHours: nullableString,
    generalInformation: nullableString,
    name: yup.string().required(),
    city: yup.string().required().nullable(),
    county: yup.string().required(),
    postcode: yup.string().required(),
    country: yup.string().required(),
    locationStatus: yup.string().required(),
    latitude: yup.string().required(),
    longitude: yup.string().required(),
    telephone: yup.string().required(),
    ecpBranchId: yup
        .number()
        .required()
        .typeError("Babbage Branch Number must be a number"),
    ibtConfig: yup.array().of(ibtSequenceSchema),
};
